/**
 * S1 (AB#2204, SG-05) — a staff member's own booking for the shared booking
 * detail. The backend scopes it (own bookings only, masked phone, no customer
 * email / history) and stamps the same `allowedTransitions` / `canMarkPaid` it
 * validates with. Disabled until a booking is opened.
 */
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../lib/queryKeys';
import { apiService } from '../services/api';

export function useStaffAppointmentDetail(id: number | null) {
    return useQuery({
        queryKey: queryKeys.appointments.staffDetail(id ?? 0),
        queryFn: () => apiService.getStaffAppointmentById(id as number),
        enabled: id != null,
        staleTime: 0,
        retry: false,
    });
}
